import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import { getWebsiteContactRequests } from "adminApi/WebsiteContactRequests/WebsiteContactRequests";
import fields from "../../json/WebsiteContactRequestsFields.json";

const WebsiteContactRequestsTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledata } = fields;

  // Fetch data
  const { data, meta, loading, error, refetch } = usePaginatedFetch(getWebsiteContactRequests, {
    page,
    limit,
    search: debouncedSearch,
    title: "Website Contact Requests",
  });


  const displayFields = generateDisplayFields(tabledata);

  const { formattedData, columns } = useTableConfig({
    data,
    page,
    limit,
    canShowAction,
    refetch,
    IsDelete: false,
    IsEdit: false,
    config: {
      entityName: "Website Contact Request",
      editUrl: "edit-website-contact-request",
      idKey: "id",
      deleteApi: () => { },
      displayFields,
    },
  });

  // Handlers
  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => setPage(p);

  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  // Render DataTable
  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
        copy: true,
        csv: true,
        pdf: true,
        print: true,
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch: handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default WebsiteContactRequestsTable;
